module.exports = __webpack_public_path__ + "fonts/qtzaintext.3427b975.woff2";